export default __webpack_public_path__ + "static/media/Math1_BasicCounting_2021.9376ad12.pdf";